import axios from 'axios'

class PublicityService {
  constructor(apiUrl) {
    this.apiUrl = apiUrl
  }

  /**
   * @author Isaac Martinez
   * @description  Get publicitys by clientId
   * @date 11-06-2024
   * @param {String} token
   * @return {Object} 
   * @memberof PublicityService
   */
  async getPublicitys(token) {
    let response = await axios.get(`${this.apiUrl}/publicity`, {
      headers: {
        'Authorization': `Bearer ${token}`
      },
    })
    return response.data.data
  }

  /**
   * @author Isaac Martinez
   * @description Get the catalog to insert in new publicity
   * @date 18-06-2024
   * @param {String} token
   * @return {Object}
   * @memberof PublicityService
   */
  async getCatalogInsert(token) {
    let response = await axios.get(`${this.apiUrl}/catalog-insert?type=publicity`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }

  /**
   * @author Isaac Martinez
   * @description Create new publicity
   * @date 25-06-2024
   * @param {Object} data
   * @param {String} token
   * @return {Object}
   * @memberof PublicityService
   */
  async setPublicity(data, token) {
    let response = await axios.post(`${this.apiUrl}/publicity`, data, {
      headers: {
        'Authorization': `Bearer ${token}`
      }

    })
    return response.data
  }

  /**
   * @author Isaac Martinez
   * @description Get publicity with details by publicityId
   * @date 03-07-2024
   * @param {String} publicityId
   * @param {String} token
   * @return {Object}
   * @memberof PublicityService
   */
  async getPublicityDetailsById(publicityId, token) {
    let response = await axios.get(`${this.apiUrl}/publicity-details?publicityId=${publicityId}`, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data.data
  }

  /**
   * @author Brayan Salas
   * @description Delete a publicity
   * @date 17-07-2024
   * @param {String} publicityId
   * @param {String} token
   * @return {Object}
   * @memberof PublicityService
   */
  async deletePublicity(publicityId, token) {
    let response = await axios.delete(`${this.apiUrl}/publicity?publicityId=${publicityId}`,
      {
        headers: {
          'Authorization': `Bearer ${token}`
        },
      })
    return response.data.data
  }

  async massivePublicities(publicities, token) {
    let response = await axios.post(`${this.apiUrl}/publicities-csv`, { publicities }, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    })
    return response.data
  }
}
export { PublicityService as default }